<template>
  <div>
    <!-- 受賞者ページおよびポートフォリオページのコメント欄出力 -->
    <div v-if="commentType == EnumCommentTypeWinner || commentType == EnumCommentTypePortfolio">
      <h2>応援メッセージ・感想<span>（{{this.comments.length}}件）</span></h2>
      <div class="messageArea">
        <div class="left">
          <div class="msgPstArea">
            <section v-for="(comment, index) in comments" :key="comment.id" class="msgPost" :class="{msgStripe: (index % 2 === 1)}">
              <p class="msgBody">
                {{comment.sentence}}
              </p>
              <img v-if="comment.isWinner" class="authenticated" src="/img/commentAuthenticated.png" alt="" style="filter: blur(0px)" />
              <p class="msgNameDate">名前：{{comment.postName}} {{dateTime(comment.createdAt)}}</p>
            </section>
          </div>
        </div>
        <div v-if="isClose()" class="right">
          <p class="inputClose">コメント受付期間は終了しました。</p>
        </div>
        <template v-if="!isClose()">
        <div v-if="formMode === 'input'" class="right">
          <p class="inputTitle">お名前</p>
          <p v-if="this.isError" style="color: red;">{{this.errorMessageName}}</p>
          <input type="text" name="personName" v-model="name" class="inputText" />
          <p class="inputTitle">コメント</p>
          <p v-if="this.isError" style="color: red;">{{this.errorMessageComment}}</p>
          <textarea name="contents" v-model="comment" rows="8" cols="50" class="inputTextbox" id="contents" ></textarea>
          <p class="inputAttention">コメントはすぐには反映されません。<br><span>1～2営業日（土日祝は含まれません）程度反映までに時間がかかります</span>ので、今しばらくお待ち下さい。</p>
          <p v-if="this.isError" style="color: red;">{{this.errorMessage}}</p>
          <a href="javascript:void(0);" class="inputBtn StandardBtn notSwipe" @click="postCommentConfirm">入力内容の確認</a>
        </div>
        <div v-else-if="formMode === 'confirm'" class="right">
          <p class="inputTitle">この内容で書き込みますがよろしいですか？</p>
          <div class="confirm">
              <p class="msgBody">
                {{this.commentConfirm.sentence}}
              </p>
              <img v-if="commentConfirm.isWinner" class="authenticated" src="/img/commentAuthenticated.png" alt=""/><p class="msgNameDate">名前：{{this.commentConfirm.postName}}  {{dateTime()}}</p>
          </div>
          <p class="inputAttention">コメントはすぐには反映されません。<br><span>1～2営業日（土日祝は含まれません）程度反映までに時間がかかります</span>ので、今しばらくお待ち下さい。</p>
          <a href="javascript:void(0);" class="confirmInputBtnOk confirmInputBtn StandardBtn notSwipe" @click="postComment">この内容で書き込む</a>
          <a href="javascript:void(0);" class="confirmInputBtn StandardBtn notSwipe" @click="formMode = 'input'">修正する</a>
        </div>
        <div v-else class="right">
          <p class="inputComplete">コメントの投稿を受け付けました</p>
          <p class="inputAttention">コメントはすぐには反映されません。<br><span>1～2営業日（土日祝は含まれません）程度反映までに時間がかかります</span>ので、今しばらくお待ち下さい。</p>
          <a href="javascript:void(0);" class="inputBtn StandardBtn notSwipe" @click="formMode = 'input'">閉じる</a>
        </div>
        </template>
      </div>
      <p class="googleCaptcha">他の利用者、または第三者に不利益を与える内容や、誹謗中傷、法律違反、その他コメント管理者が不適切な内容であると判断した場合は、コメントを非表示・または削除することがあります。また、やむを得ない場合は、コメント管理者の判断によりコメント欄を予告なく閉鎖する場合があります。</p>
      <p class="googleCaptcha">このページのコメントボードはGoogleのreCAPTCHAによって保護されています。Googleの <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>と<a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">利用規約</a>が適用されます。</p>
    </div>

    <!-- 画像詳細ページのコメント欄出力 -->
    <div v-else>
      <!-- 画像詳細ページ1024px以上または、640px以下のコメント欄出力 -->
      <!-- 1024px以上または、640px以下の場合、コメント欄は切り替え式になる -->
      <div class="commentAreaBlock">
        <div v-if="isCommentDisplayView" style="display: block;">
          <div v-if="isClose()" class="messageHead">
            <h3>応援メッセージ・感想<span>（{{this.comments.length}}件）</span></h3>
            <p class="inputClose">コメント受付期間は終了しました。</p>
          </div>
          <div v-if="!isClose()" class="messageHead">
            <h3>応援メッセージ・感想<span>（{{this.comments.length}}件）</span></h3>
            <a href="javascript:void(0);" @click="isCommentDisplayView = false" class="StandardBtn notSwipe">コメントを書く</a>
          </div>
          <div class="messageBopdy">
            <div class="msgPstArea">
              <section class="msgPost" v-for="(comment, index) in comments" :key="comment.id" :class="{msgStripe: (index % 2 === 1)}">
                <p class="msgBody">{{comment.sentence}}</p>
                <img v-if="comment.isWinner" class="authenticated" src="/img/commentAuthenticated.png" alt="" style="filter: blur(0px)" /><p class="msgNameDate">名前：{{comment.postName}} {{dateTime(comment.createdAt)}}</p>
              </section>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="formMode === 'input'" class="msgInput" style="display: block;">
            <p class="inputTitle">お名前</p>
            <input type="text" name="personName" class="inputText" id="personName" v-model="name" />
            <div v-if="this.isError" style="color: red;">{{this.errorMessageName}}</div>
            <p class="inputTitle">コメント</p>
            <textarea name="contents" rows="8" cols="50" class="inputTextbox" id="contents" v-model="comment" ></textarea>
            <div v-if="this.isError" style="color: red;">{{this.errorMessageComment}}</div>
            <p class="inputAttention">コメントはすぐには反映されません。<br><span>1～2営業日（土日祝は含まれません）程度反映までに時間がかかります</span>ので、今しばらくお待ち下さい。</p>
            <p v-if="this.isError" style="color: red;">{{this.errorMessage}}</p>
            <a href="javascript:void(0);" class="inputBtn StandardBtn notSwipe" id="" @click="postCommentConfirm">入力内容の確認</a>
            <a href="javascript:void(0);" class="inputBtn StandardBtn notSwipe" @click="isCommentDisplayView = true">戻る</a>
          </div>
          <div v-else-if="formMode === 'confirm'" class="right">
            <div class="msgInput" style="display: block;">
              <p class="inputTitle">この内容で書き込みますがよろしいですか？</p>
              <div class="confirm">
                <p class="msgBody">
                  {{this.commentConfirm.sentence}}
                </p>
                <img v-if="commentConfirm.isWinner" class="authenticated" src="/img/commentAuthenticated.png" alt=""/><p class="msgNameDate">名前：{{this.commentConfirm.postName}} {{dateTime()}}</p>
              </div>
              <p class="inputAttention">コメントはすぐには反映されません。<br><span>1～2営業日（土日祝は含まれません）程度反映までに時間がかかります</span>ので、今しばらくお待ち下さい。</p>
              <a href="javascript:void(0);" class="confirmInputBtnOk confirmInputBtn StandardBtn notSwipe" @click="postComment">この内容で書き込む</a>
              <a href="javascript:void(0);" class="confirmInputBtn StandardBtn notSwipe" @click="formMode = 'input'">修正する</a>
            </div>
          </div>
          <div v-else style="text-align: center;" class="complete">
            <p class="inputComplete">コメントの投稿を受け付けました</p>
            <p class="inputAttention">コメントはすぐには反映されません。<br><span>1～2営業日（土日祝は含まれません）程度反映までに時間がかかります</span>ので、今しばらくお待ち下さい。</p>
            <a href="javascript:void(0);" class="inputBtn StandardBtn notSwipe" @click="formMode = 'input'">閉じる</a>
          </div>
        </div>
      </div>

      <!-- 画像詳細ページ640px〜1024pxのコメント欄出力 -->
      <!-- 640px〜1024pxの場合、コメント欄は常時表示されっぱなしとなる -->
      <div class="commentAreaBlock1024">
        <div>
          <div class="messageHead">
            <h3>応援メッセージ・感想<span>（{{this.comments.length}}件）</span></h3>
          </div>
          <div class="messageBopdy">
            <div class="msgPstArea">
              <section class="msgPost" v-for="(comment, index) in comments" :key="comment.id" :class="{msgStripe: (index % 2 === 1)}">
                <p class="msgBody">{{comment.sentence}}</p>
                <img v-if="comment.isWinner" class="authenticated" src="/img/commentAuthenticated.png" alt="" style="filter: blur(0px)" /><p class="msgNameDate">名前：{{comment.postName}} {{dateTime(comment.createdAt)}}</p>
              </section>
            </div>
            <div v-if="isClose()" class="msgInput" style="display: block;">
              <p class="inputClose">コメント受付期間は終了しました。</p>
            </div>
            <template v-if="!isClose()">
            <div v-if="formMode === 'input'" class="msgInput" style="display: block;">
              <p class="inputTitle">お名前</p>
              <input type="text" name="personName" class="inputText" id="personName" v-model="name" />
              <div v-if="this.isError" style="color: red;">{{this.errorMessageName}}</div>
              <p class="inputTitle">コメント</p>
              <textarea name="contents" rows="8" cols="50" class="inputTextbox" id="contents" v-model="comment" ></textarea>
              <div v-if="this.isError" style="color: red;">{{this.errorMessageComment}}</div>
              <p class="inputAttention">コメントはすぐには反映されません。<br><span>1～2営業日（土日祝は含まれません）程度反映までに時間がかかります</span>ので、今しばらくお待ち下さい。</p>
              <p v-if="this.isError" style="color: red;">{{this.errorMessage}}</p>
              <a href="javascript:void(0);" class="inputBtn StandardBtn notSwipe" id="" @click="postCommentConfirm">入力内容の確認</a>
            </div>
            <div v-else-if="formMode === 'confirm'" class="msgInput" style="display: block;">
              <p class="inputTitle">この内容で書き込みますがよろしいですか？</p>
              <div class="confirm">
                <p class="msgBody">
                  {{this.commentConfirm.sentence}}
                </p>
                <img v-if="commentConfirm.isWinner" class="authenticated" src="/img/commentAuthenticated.png" alt=""/><p class="msgNameDate">名前：{{this.commentConfirm.postName}} {{dateTime()}}</p>
              </div>
              <p class="inputAttention">コメントはすぐには反映されません。<br><span>1～2営業日（土日祝は含まれません）程度反映までに時間がかかります</span>ので、今しばらくお待ち下さい。</p>
              <a href="javascript:void(0);" class="confirmInputBtnOk confirmInputBtn StandardBtn notSwipe" @click="postComment">この内容で書き込む</a>
              <a href="javascript:void(0);" class="confirmInputBtn StandardBtn notSwipe" @click="formMode = 'input'">修正する</a>
            </div>
            <div v-else style="text-align: center;" class="msgInput ">
              <p class="inputComplete">コメントの投稿を受け付けました</p>
              <p class="inputAttention">コメントはすぐには反映されません。<br><span>1～2営業日（土日祝は含まれません）程度反映までに時間がかかります</span>ので、今しばらくお待ち下さい。</p>
              <a href="javascript:void(0);" class="inputBtn StandardBtn notSwipe" @click="formMode = 'input'">閉じる</a>
            </div>
            </template>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { Comments } from '../../api/'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import moment from 'moment-timezone'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
  },
  props: [
    'categoryId',
    'commentType'
  ],
  data () {
    return {
      isPostCommentConfirmPushed: false,
      isPostCommentPushed: false,
      comments: [],
      name: '',
      comment: '',
      errorMessage: '',
      errorMessageName: '',
      errorMessageComment: '',
      isError: false,
      formMode: 'input', // input:入力フォーム表示 confirm:確認画面表示 complete:書き込み完了画面
      isCommentDisplayView: true, // 受賞者画面以外で、ここがtrueの場合コメント表示モードfalseの場合書き込み画面
      commentConfirm: null,
      timerId: null,
      nowDateTime: null
    }
  },
  methods: {
    load () {
      if (!this.categoryId) return
      this.clearForm()
      // コメント一覧を毎回APIからデータを取得する
      Comments.getComments({
        categoryId: this.categoryId,
        commentType: this.commentType
      }).then((result) => {
        this.comments = result.data
      }).catch((error) => {
        console.log(error)
      })
    },
    dateTime (time = new Date()) {
      // return moment(time).format('YYYY/MM/DD HH:mm')
      return moment(time).format('YYYY/MM/DD')
    },
    // 確認画面表示処理
    postCommentConfirm () {
      if (this.isPostCommentConfirmPushed) return
      this.isPostCommentConfirmPushed = true
      setTimeout(() => { this.isPostCommentConfirmPushed = false }, 1000) // 連打できないようにn秒間のバッファを設けた

      this.name = this.name ? this.name.trim() : ''
      this.comment = this.comment ? this.comment.trim() : ''

      if (this.isCommentKeyError()) {
        return
      }

      // 書き込み確認処理
      Comments.postCommentConfirm({
        commentType: this.commentType,
        categoryId: this.categoryId,
        postName: this.name,
        sentence: this.comment
      }).then((result) => {
        // this.clearForm()
        this.formMode = 'confirm' // 確認画面に切り替え
        this.commentConfirm = result.data.comment

        // イベント記録
        this.$ga.event('Comment', 'confirm', this.commentType, this.categoryId)
      }).catch((error) => {
        console.log(error)
        this.isError = true
        this.errorMessage = error.result.message
        this.errorMessageName = this.getErrorMessage('postName', error.result.errors)
        this.errorMessageComment = this.getErrorMessage('sentence', error.result.errors)
      })
    },
    async postComment () {
      if (this.isPostCommentPushed) return
      this.isPostCommentPushed = true
      setTimeout(() => { this.isPostCommentPushed = false }, 2000) // 連打できないようにn秒間のバッファを設けた
      this.name = this.name ? this.name.trim() : ''
      this.comment = this.comment ? this.comment.trim() : ''

      // reCAPTCHA読み出し
      await this.$recaptchaLoaded()
      // reCAPTCHAのトークン取得
      const token = await this.$recaptcha('comment')
      // 書き込み処理
      Comments.postComment({
        commentType: this.commentType,
        categoryId: this.categoryId,
        postName: this.name,
        sentence: this.comment,
        recaptchaToken: token
      }).then((result) => {
        this.clearForm()
        this.formMode = 'complete' // 投稿完了メッセージに切り替え

        // イベント記録
        this.$ga.event('Comment', 'write', this.commentType, this.categoryId)
      }).catch((error) => {
        this.isError = true
        this.errorMessage = error.result.message
        this.errorMessageName = this.getErrorMessage('postName', error.result.errors)
        this.errorMessageComment = this.getErrorMessage('sentence', error.result.errors)
      })
    },
    isCommentKeyError () {
      let isCkError = false
      const name = this.name.trim()
      const matches = name.match(/ck[0-9]+/g)
      if (matches && matches[0].length > 6) {
        if (matches[0].length !== 14) {
          isCkError = true
          this.isError = true
          this.errorMessage = '入力項目に誤りがあります、入力内容をお確かめください'
          this.errorMessageName = 'コメントキーの桁数が不正です。'
        } else {
          const index = name.indexOf(matches[0])
          if (index !== 0 || name.length !== 14) {
            isCkError = true
            this.isError = true
            this.errorMessage = '入力項目に誤りがあります、入力内容をお確かめください'
            this.errorMessageName = 'コメントキー以外の文字列が含まれています。'
          }
        }
      }
      return isCkError
    },
    backCommentList () {
      this.isCommentDisplayView = true
      this.clearForm()
    },
    closeAndBackCommentList () {
      this.formMode = 'input' // 入力画面に切り替え
      this.backCommentList()
    },
    getErrorMessage (field, errors) {
      for (const error of errors) {
        console.log(error)
        if (error.field === field) {
          return error.code
        }
      }
    },
    clearForm () {
      this.name = ''
      this.comment = ''
      this.isError = false
      this.errorMessageName = ''
      this.errorMessageComment = ''
      this.formMode = 'input'
    },
    // 現在時刻のセット
    setNow () {
      this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      this.timerId = setInterval(function () {
        this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      }.bind(this), 1000)
    },
    isClose () {
      return true
      // return (this.nowDateTime > '20201031 23:59:59')
    }
  },
  watch: {
    categoryId: function (value) {
      // コメント読み込み
      this.load()
    }
  },
  created () {
    // コメント読み込み
    this.load()
    // タイマー起動
    this.setNow()
  },
  beforeDestroy () {
    clearInterval(this.timerId)
  },
  mounted () {
  }
}
</script>
